import TrustBox from './TrustBox';

export default TrustBox;
